import React from "react";
import {useIntl} from "react-intl";
import {EMY_PROJECT_STATUSES, PROPOSAL_STATUSES} from "../helpers/StatusHelpers";

export const EmyProjectStatus = ({status = EMY_PROJECT_STATUSES.UNDER_REVIEW.key}) => {
  const {formatMessage} = useIntl();

  return (
    <span className={`label label-inline label-${EMY_PROJECT_STATUSES[status].className}`}>
      {formatMessage({id:status})}
    </span>
  )
}

export const EmyProposalStatus = ({status = PROPOSAL_STATUSES.PENDING.key}) => {
  const {formatMessage} = useIntl();

  return (
    <span className={`label label-inline label-${PROPOSAL_STATUSES[status].className}`}>
      {formatMessage({id:status})}
    </span>
  )
}

